import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const ShowLink = styled(Typography, {
  name: 'ShowLink',
  slot: 'Root',
  skipSx: true,
})(`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 22px;
  text-transform: capitalize;
  color :#1565c0;
`)
